import React from "react";
import { Helmet } from "react-helmet";
import MegaHeader from "../components/MegaHeader/MegaHeader";
import Footer from "../components/footer/Footer";
import SoftwareCompanyCta from "../components/software-company-cta/SoftwareCompanyCta";
import ServicesPageBanner from "../components/services-page-banner/ServicesPageBanner";
import TrustedPartner from "../components/trustedPartners/TrustedPartner";
import OurServices from "../components/our-services/OurServices";
import FAQ from "../components/Fqas/FAQ";
import TrendsInsights from "../components/trends-n-insights/TrendsInsights";
import DarkRoadMap from "../components/dark-roadmap/darkRoadMap";
import SimpleModels from "../components/simpleEngagementModels";
import PioneeringChange from "../components/pioneeringChange/PioneeringChange";
import tabData from "../data/industryData";
import { useTranslation } from "react-i18next";
import NewTestimonials from "../components/new-testimonials/NewTestimonials";
import WhyChooseUs from "../components/why-choose-us/WhyChooseUs";
import NewCaseStudySection from "../components/new-case-study-section/NewCaseStudySection";
import NewBenefitsSection from "../components/new-banefits-section/NewBenefitsSection";
import IndustriesTabs from "../components/industries-tabs/IndustriesTabs";
import CoverTheStack from "../components/coverthestack/CoverTheStack";
import ChatBotWorkFlow from "../components/chatbbot-workflow/ChatBotWorkFlow";
import IntigrationIconsSection from "../components/integration-icons-section/IntigrationIconsSection";
import MegaMenu from "../components/MegaMenu/MegaMenu";
import AreasWeServe from "../components/areas-we-serve/AreasWeServe";
import { AiChatBotPageDataNewYork } from "../data/ai-chatbot-data-newyork";
import { AiChatBotPageData } from "../data/ai-chatbot-data";
import TechStack from "../components/techstack/TechStack";
import ChatbotIntigratedSection from "../components/ChatBotIntigratedSection/ChatbotIntigratedSection";
import SecurityFIrstSection from "../components/SecurityFirstSection/SecurityFIrstSection";
import NewRoadMap from "../components/new-raodmap-section/NewRoadMap";
import ModelAgnostic from "../components/ModelAgnostic/ModelAgnostic";
import ChatbotBanner from "../components/ChatbotBanner/ChatbotBanner";

const AIChatBotServicesNewYork = () => {

    const { t } = useTranslation("footer");
    const footerCtaContent = t("footerCtaContent", { returnObjects: true });

    const { t: stackData } = useTranslation("aiDevelopmentPageContent");
    const coverTheStackData = stackData("aiDevCoverTheStackSection", {
        returnObjects: true,
    });

    return (
        <>
            <Helmet>
                <title>AI Chatbot Development Services in New York | Bitsclan</title>
                <meta
                    name="description"
                    content="Enhance customer engagement with Bitsclan’s AI Chatbot Development Services in New York. Automate support, reduce costs & improve efficiency. Contact us now!"
                />
                <meta name="robots" content="index, follow, max-snippet:-1, max-image-preview:large, max-video-preview:-1" />
                <link rel="canonical" href="https://bitsclan.com/ai-chatbot-development-newyork" />
            </Helmet>

            <MegaMenu />

            <ChatbotBanner
                shortHeading="New York AI Chatbot Development Services"
                mainHeading="New York's Trusted Partner for Intelligent <span>AI Chatbot Solutions</span>"
                description="Are you in search of AI chatbot development services in New York that deliver top-notch scalable AI solutions? Our expert AI chatbot developers specialize in developing innovative AI-powered chatbots, software & applications customized to your unique business requirements."
                bannerImage="/images/why-us-section/chatbot-banner.png"
            />
            <TrustedPartner category={"chatbot"} showGoogleIcons={true} heading="Trusted & Partnered by Businesses Worldwide to Build Smarter Chatbot Solutions" />

            <OurServices
                shortHeading={"Intelligent Chatbot Solutions Tailored for New York Companies"}
                buttonText="Hire Chatbot Developer in New York"
                servicesCardsData={AiChatBotPageDataNewYork?.services}
                mainHeading="Enterprise-Grade Chatbot Development for Smarter Business Engagement"
                description="Leverage the power of AI chatbots to boost efficiency, enhance customer-dealing, & explore new opportunities. Our <a href='/ai-chatbot-development-services' class='text-black'>customized AI chatbot development solutions</a> are designed to revolutionize your business operations in New York & boost revenue growth."
            />

            <NewTestimonials
                shortHeading={AiChatBotPageDataNewYork?.testimonialData?.shortHeading}
                mainHeading={AiChatBotPageDataNewYork?.testimonialData?.mainHeading}
                description={AiChatBotPageDataNewYork?.testimonialData?.description}
                content={AiChatBotPageDataNewYork?.testimonialData?.testimonials}
            />

            <WhyChooseUs
                heading={AiChatBotPageDataNewYork?.whyUsSectionData?.heading}
                greenHeading={AiChatBotPageDataNewYork?.whyUsSectionData?.greenHeading}
                content={AiChatBotPageDataNewYork?.whyUsSectionData?.content}
                shortHeading={AiChatBotPageDataNewYork?.whyUsSectionData?.shortHeading}
                stats={AiChatBotPageDataNewYork?.whyUsSectionData?.stats}
                cta={AiChatBotPageDataNewYork?.whyUsSectionData?.cta}
                sectionImage={AiChatBotPageDataNewYork?.whyUsSectionData?.image}
            />

            <NewCaseStudySection
                heading={AiChatBotPageDataNewYork?.caseStudyContent?.heading}
                shortHeading={AiChatBotPageDataNewYork?.caseStudyContent?.shortHeading}
                description={AiChatBotPageDataNewYork?.caseStudyContent?.description}
                filter={"chatbot"}
            />

            <ChatbotIntigratedSection content={AiChatBotPageData?.integrationsData} />

            <SimpleModels content={AiChatBotPageDataNewYork?.engagementModels} />

            <TechStack content={AiChatBotPageData?.techStackData} />

            {/* <ChatBotWorkFlow /> */}

            {/* <IntigrationIconsSection content={AiChatBotPageDataNewYork?.chatbotIntigration} /> */}

            <NewBenefitsSection />

            <PioneeringChange
                shortHeading="Industries We Serve"
                tabData={AiChatBotPageDataNewYork?.industriesSectionMain}
                greenHeading={"Solutions Built for the Unique Demands of Every Industry"}
                mainHeading={"Specialized Chatbot "}
                content={"Driving innovation & transforming industries with advanced ai chatbot development expertise & actionable insights."}
                serviceTags={[
                    { title: "AI Chatbots", link: "/ai-chatbot-development-services" },
                    { title: "Virtual Assistants", link: "/ai-automation-agency" },
                    { title: "Conversational AI", link: "/generative-ai-development-services" }
                ]}
            />

            <SecurityFIrstSection />

            <ModelAgnostic />

            <CoverTheStack
                whereStart={"Deep learning frameworks"}
                shortHeading={"Technology Stack for Chatbot Development"}
                mainHeading={"Foundational Technologies Driving Conversational Intelligence"}
                subHeading={
                    "The right technology stack for chatbot development will depend on your intended use cases & channels. We engage with the leading providers from Microsoft Azure & AWS to Google Cloud for dependable, secure, & scalable solutions."
                }
                tabs={AiChatBotPageDataNewYork?.techStack?.tabs}
                tabItems={AiChatBotPageDataNewYork?.techStack?.tabItems}
            />

            <NewRoadMap roadmapContent={AiChatBotPageData?.roadmapContent} />

            <TrendsInsights
                category="ai-developmet"
                heading={AiChatBotPageDataNewYork?.trendingInsights.heading}
                description={AiChatBotPageDataNewYork?.trendingInsights.description}
            />

            <FAQ
                faqs={AiChatBotPageDataNewYork.faqSection.questionAnswers}
                mainHeading={AiChatBotPageDataNewYork.faqSection.heading}
            />

            <AreasWeServe />

            <SoftwareCompanyCta content={AiChatBotPageDataNewYork?.companyCta} />
            <Footer />
        </>
    )
}

export default AIChatBotServicesNewYork